import React, { useEffect, useState } from 'react';
import Axios from '../../config/axios';
import { toast, confirm } from '@rickylandino/react-messages';
import { useNavigate, useLocation } from "react-router-dom";
import { Empty, Spin, Alert, Select, Table, message } from 'antd';
import { useForm, Controller } from "react-hook-form";
import { Button } from 'react-bootstrap';
import { downloadReportByName } from '../../services/ReportsService';
import { getShowMaster } from '../../services/ShowMasterService';

export default function WidgetRegistrationScorecard(props) {
    const userInfo = JSON.parse(window.sessionStorage.getItem("userInfo"));

    const [state, setState] = useState({
        showList: [],
        shows: [],
        mailcds: [],
        priorshowcode: "",
        priorshowmailcodecounts: "",
        kvp_priorshowmailcodecounts: {},
        totpriorshowmailcodes: 0,
        selectedShowCode: "",
        selectedshowname: "",
        priorshowname: "",
        hidepriorshowcolumns: true,
        dataLoaded: false,
        showsSelected: false,
        daysOut: ''
    });

    const { register, getValues, setValue, control, watch } = useForm();

    const { Option } = Select;

    const [selectedRowKeys, setSelectedRowKeys] = useState(['']);

    useEffect(() => {
        
    }, []);

    //useEffect(() => {
    //    console.log(props.showsSelected);

    //}, [props]);

    useEffect(() => {
        var futureShowList = [];
        var showList = [];

        setValue('formFields.shows', []);
        setValue('formFields.targetshow', 'select-target-show');

        let postdata = {};
        Axios.post(`/api/GetActiveShowList`, postdata
        ).then(response => {
            showList = response.data;
            setValue('showList', showList);

            //now, load list of future shows
            const today = new Date();
            showList.forEach(item => {
                const itemDate = new Date(item.startdate);
                if (itemDate >= today) {
                    futureShowList.push(item);
                }
            });
            setValue('futureShowList', futureShowList);

            setState({
                ...state,
                shows: [],
                dataLoaded: false,
                showsSelected: false,
                daysOut: ''
            });
        }).catch(error => {
            console.log(error);
        });
    }, [props]);

    function LoadData() {
        setState({
            ...state,
            showsSelected: true,
            dataLoaded: false
        });

        let postdata = {
            showcode: getValues().formFields.targetshow,
            showslist: String(getValues().formFields.shows)
        };

        Axios.post(`/api/GetRegistrationScorecard`, postdata
        ).then(response => {
            let shows = response.data;
            setState({
                ...state,
                shows,
                dataLoaded: true,
                showsSelected: true
            });
        }).catch(error => {
            console.log(error);
        });
    }

    function renderPercentage(vipCount, totalReg) {
        if (vipCount !== null && totalReg !== null && parseInt(totalReg) !== 0) {
            return round((vipCount / totalReg) * 100, 0).toString() + '%';
        }
        else {
            return '';
        }
    }

    function round(value, precision) {
        var multiplier = Math.pow(10, precision || 0);
        return Math.round(value * multiplier) / multiplier;
    }

    const columns = [
        {
            dataIndex: 'showcode',
            title: 'showcode',
            key: 'showcode',
            hidden: true
        },
        {
            dataIndex: 'show_abbrev',
            title: 'Show',
            key: 'show_abbrev',
            align: 'center'
        },
        {
            dataIndex: 'exhibitors',
            title: 'EXBs',
            key: 'exhibitors',
            align: 'center'
        },
        {
            dataIndex: 'totalReg',
            title: 'Total',
            key: 'totalReg',
            align: 'center'
        },
        {
            dataIndex: 'vipCount',
            title: 'VIPs',
            key: 'vipCount',
            align: 'center'
        },
        {
            title: '% VIPs',
            align: 'center',
            render: (record) => (
                renderPercentage(record.vipCount, record.totalReg)
            ),
        },
        {
            dataIndex: 'buyingPower_0_6',
            title: 'Buying Power 0-6',
            key: 'buyingPower_0_6',
            align: 'center'
        },
        {
            dataIndex: 'buyingPower_7_12',
            title: 'Buying Power 7-12',
            key: 'buyingPower_7_12',
            align: 'center'
        }
        ].filter(item => !item.hidden);

    const onSelectChange = (newSelectedRowKeys) => {
        setSelectedRowKeys(newSelectedRowKeys);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
        columnWidth: 0, // Set the width to 0
        renderCell: () => "", // Render nothing inside
    };

    function getDaysOut(futureDateStr) {
        const today = new Date();
        const futureDate = new Date(futureDateStr);

        // Set time to midnight for an accurate full-day difference
        today.setHours(0, 0, 0, 0);
        futureDate.setHours(0, 0, 0, 0);

        const diffTime = futureDate - today;
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        return diffDays;
    }

    function handleTargetShowsChange(value) {
        var daysOut = '';

        setValue('formFields.targetshow', value);

        if (getValues().formFields.targetshow === 'select-target-show') {
            setState({
                ...state,
                shows: [],
                dataLoaded: false,
                showsSelected: false,
                daysOut: ''
            });
        }
        else {
            var futureShowList = getValues().futureShowList;

            futureShowList.forEach(item => {
                /*const itemDate = new Date(item.startdate);*/
                if (item.showcode === value) {
                    daysOut = getDaysOut(item.startdate);
                }
            });

            setState({
                ...state,
                dataLoaded: false,
                showsSelected: false,
                daysOut: daysOut
            });
        }
    }

    function handleShowsChange(value) {
        setValue('formFields.shows', value);

        if (getValues().formFields.shows.length === 0) {
            setState({
                ...state,
                shows: [],
                dataLoaded: false,
                showsSelected: false,
                daysOut: ''
            });
        }
        else {
            setState({
                ...state,
                dataLoaded: false,
                showsSelected: false
            });
        }
    }

    function handleSubmit() {
        if (getValues().formFields.targetshow === 'select-target-show') {
            toast.error('You must select a target show');

            return;
        }

        if (getValues().formFields.shows.length === 0) {
            toast.error('You must select at least one show to compare');

            return;
        }

        LoadData();
    }

    function handleReset() {
        setValue('formFields.shows', []);
        setValue('formFields.targetshow', 'select-target-show');

        setState({
            ...state,
            shows: [],
            dataLoaded: false,
            showsSelected: false,
            daysOut: ''
        });
    }

    function handleExportToCSV() {
        const key = "downloademailtemplate";
        message.loading({
            content: 'CSV generation in progress...',
            key,
            duration: 0,
            //style: {
            //    position: "fixed",
            //    bottom: 0,
            //    left: 0
            //},
        });

        let postdata = {
            reportName: 'Registration Scorecard',
            showcode: getValues().formFields.targetshow,
            showslist: String(getValues().formFields.shows)
        };

        downloadReportByName(postdata).then(response => {
            //console.log(response);
            console.log(response.headers['content-disposition']);

            if (response.data) {
                //uses the fileName sent down from API enpoint in response header
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                a.download = 'RegistrationScorecard.csv';
                a.click();
                window.URL.revokeObjectURL(url);

                message.destroy(key);
            } else {
                toast.warning("Report is not yet defined");
            }
        });
    }

    return (
        <div className="row">
            <div className="col-lg-3 pb-2">
                Select Target Show<br />
                <Select id="ddSShows"
                    value={getValues().formFields?.targetshow}
                    className="form-control-custom"
                    mode="single"
                    placeholder="Select you target show"
                    onChange={handleTargetShowsChange}
                    className="form-control-custom w-100"
                    bordered={false}
                >
                    <Option value="select-target-show">Select a Show</Option>
                    {getValues().futureShowList?.map((show) => <Option key={show.showcode} value={show.showcode}>{show.name}</Option>)}
                </Select>&nbsp;&nbsp;&nbsp;
            </div>
            <div className="col-lg-9">
                <br />
                {state.daysOut !== '' &&
                    state.daysOut + ' Days Out'
                }
            </div>

            <div className="col-lg-10">
                Select One Or More Shows<br />
                <Select
                    id="ddSShows"
                    value={getValues().formFields?.shows}
                    className="form-control-custom w-100"
                    mode="multiple"
                    placeholder="Select one or more Shows"
                    onChange={handleShowsChange}
                    bordered={false}
                    showSearch
                    filterOption={(input, option) =>
                        option.children.toLowerCase().includes(input.toLowerCase())
                    }
                >
                    {getValues().showList
                        ?.filter((show) => show.showcode !== getValues().formFields?.targetshow)
                        .map((show) => (
                            <Option key={show.showcode} value={show.showcode}>
                                {show.name}
                            </Option>
                        ))}
                </Select>
            </div>
            <div className="col-lg-2">
                <br />
                <button className="btn btn-outline-primary ms-3" onClick={handleSubmit}>Submit</button>&nbsp;&nbsp;
                <button className="btn btn-link ms-3" onClick={handleReset}>Reset</button>
            </div>

            <div className="col-lg-12">&nbsp;</div>

            {state.showsSelected ?
                <div className="col-lg-12">
                    <Spin spinning={!state.dataLoaded}>
                        <div style={!state.dataLoaded ? {} : { display: 'none' }}>
                            <Alert
                                message="Loading Shows"
                                description="Please stand by while we prepare the scorecard"
                                type="info"
                            />
                        </div>
                        {state.dataLoaded &&
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    {state.shows.length === 0 ?
                                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={
                                            <span>
                                                No Scorecard information found for the selected shows
                                            </span>
                                        } />
                                        :
                                        <>
                                            <div className="fullTable form-group col-lg-12">
                                                <Table className="custom-ant-selection"
                                                    rowKey={item => item.showcode}
                                                    hideSelectionColumn={true}
                                                    bordered
                                                    dataSource={state.shows}
                                                    columns={columns}
                                                    pagination={{
                                                        defaultPageSize: 25,
                                                        showSizeChanger: true,
                                                        pageSizeOptions: ['10', '25', '50', '100'],
                                                        showTotal: (total, range) => (
                                                            <span className="color-dark-blue" style={{ left: 0, position: "absolute", fontSize: "large", fontWeight: "bold" }}>
                                                                Showing {range[0]}-{range[1]} of {total}
                                                            </span>
                                                        )
                                                    }}
                                                />
                                            </div>
                                            <div className="col-lg-12">
                                                <br />
                                                <button className="btn btn-outline-primary ms-3" onClick={handleExportToCSV}>Export To CSV</button>
                                            </div>
                                        </>
                                    }
                                </div>
                            </div>
                        }
                    </Spin>
                </div>
                :
                <>
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={
                        <span>
                            Select One Or More Shows To Display Scorecard
                        </span>
                    } />
                </>
            }
        </div>
    );
}